(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
// Mobile-only footer behavior; move original links, never clone consent actions.
if (!customElements.get('ks-footer-mobile')) {
  customElements.define('ks-footer-mobile', class extends HTMLElement {
    connectedCallback() {
      this.footer = this.closest('footer');
      if (!this.footer) return;
      this.media = window.matchMedia('(max-width: 749px)');
      this.moves = [];
      this.footerVisible = false;
      this.wishlist = [...document.querySelectorAll('a.button-floating')].filter(link => {
        try { return new URL(link.href, location.href).pathname.replace(/\/$/, '').endsWith('/pages/wunschliste'); }
        catch { return false; }
      });
      this.onMedia = () => this.update();
      this.media.addEventListener('change', this.onMedia);
      this.mutations = new MutationObserver(() => this.update());
      this.intersection = new IntersectionObserver(entries => {
        this.footerVisible = entries.some(entry => entry.isIntersecting && entry.intersectionRect.height > 0);
        this.updateWishlist();
      });
      this.intersection.observe(this.footer);
      this.update();
    }

    key(link) {
      try { const url = new URL(link.getAttribute('href'), location.href); return url.origin + url.pathname.replace(/\/$/, '') + url.search + url.hash; }
      catch { return link.getAttribute('href'); }
    }

    update() {
      this.mutations.disconnect();
      // Restore before each calculation, including viewport changes and editor updates.
      this.restore();
      const source = this.footer.querySelector('.policy-links');
      const menus = [...this.footer.querySelectorAll('.footer-block--menu')];
      const targetBlock = menus.find(block => block.querySelector('.footer-block__heading')?.textContent.trim().toLocaleLowerCase('de') === 'wichtige informationen');
      const target = targetBlock?.querySelector('ul.footer-block__details-content');
      if (this.media.matches && source && target) {
        const seen = new Set(menus.flatMap(block => [...block.querySelectorAll('a[href]')]).map(link => this.key(link)));
        for (const item of [...source.children]) {
          const link = item.querySelector('a[href]');
          if (!link) continue;
          const key = this.key(link);
          if (seen.has(key)) continue;
          const placeholder = document.createComment('original policy position');
          item.before(placeholder);
          this.moves.push({ item, link, placeholder, itemClass: item.getAttribute('class'), linkClass: link.getAttribute('class') });
          item.classList.add('footer-relocated-policy');
          link.classList.add('link', 'link--text', 'list-menu__item', 'list-menu__item--link');
          target.appendChild(item);
          seen.add(key);
        }
        // Only hide when every source item is an understood link and has a visible destination.
        const safe = [...source.children].every(item => {
          const link = item.querySelector('a[href]');
          return link && seen.has(this.key(link));
        });
        this.footer.classList.toggle('footer--policies-merged', safe);
      }
      this.updateWishlist();
      this.mutations.observe(this.footer, { childList: true, subtree: true });
    }

    restore() {
      for (const move of this.moves) {
        if (move.placeholder.parentNode) move.placeholder.replaceWith(move.item);
        for (const [node, value] of [[move.item, move.itemClass], [move.link, move.linkClass]]) {
          if (value === null) node.removeAttribute('class'); else node.setAttribute('class', value);
        }
      }
      this.moves = [];
      this.footer.classList.remove('footer--policies-merged');
    }

    updateWishlist() {
      const hide = this.media.matches && this.footerVisible;
      this.wishlist.forEach(link => link.classList.toggle('ks-footer-covered', hide));
    }

    disconnectedCallback() {
      this.mutations?.disconnect();
      this.intersection?.disconnect();
      this.media?.removeEventListener('change', this.onMedia);
      if (this.footer) this.restore();
      this.wishlist?.forEach(link => link.classList.remove('ks-footer-covered'));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Shopify replaces the cart icon contents after cart changes. Preserve its label.
  if (!customElements.get('ks-header-label')) {
    customElements.define('ks-header-label', class extends HTMLElement {
      connectedCallback() {
        this.cart = this.parentElement.querySelector('#cart-icon-bubble');
        if (!this.cart) return;
        const ensureLabel = () => {
          if (this.cart.querySelector('.header__action-label')) return;
          const label = document.createElement('span');
          label.className = 'header__action-label';
          label.setAttribute('aria-hidden', 'true');
          label.textContent = this.dataset.label;
          this.cart.appendChild(label);
        };
        ensureLabel();
        this.observer = new MutationObserver(ensureLabel);
        this.observer.observe(this.cart, { childList: true });
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
